import type { AxiosError } from 'axios'

export type TApiErrorResponse = {
  message?: string
  detail?: string | { msg: string }[]
  error_code?: string
}

export const getApiErrorMessage = (error: unknown, fallback = 'Something went wrong'): string => {
  if (!error) {
    return fallback
  }

  const axiosError = error as AxiosError<TApiErrorResponse>
  const data = axiosError.response?.data

  if (typeof data?.message === 'string') {
    return data.message
  }

  if (typeof data?.detail === 'string') {
    return data.detail
  }

  if (Array.isArray(data?.detail) && data.detail.length > 0) {
    return data.detail.map((entry) => entry.msg).join(', ')
  }

  if (axiosError.message) {
    return axiosError.message
  }

  return fallback
}

export const isAnonChatDisabledError = (error: unknown): boolean => {
  if (!error) {
    return false
  }

  const axiosError = error as AxiosError<TApiErrorResponse>
  
  // Check for 403 status and specific error code
  return (
    axiosError.response?.status === 403 &&
    axiosError.response?.data?.error_code === 'ANON_CHAT_DISABLED'
  )
}
